module.exports = __webpack_public_path__ + "img/20200515_164248.cc7d231a.jpg";